function Preload() {
    return (
        <div className="fixed inset-0 bg-[#F7F3EC] flex flex-col items-center justify-center z-[9999]">
            <div className="flex gap-1.5 mb-4">
                {[0, 160, 320].map((d) => (
                    <span
                        key={d}
                        className="w-2 h-2 rounded-full bg-[#C4622D] animate-bounce"
                        style={{ animationDelay: `${d}ms` }}
                    />
                ))}
            </div>
            <small className="text-[0.68rem] tracking-[0.16em] uppercase text-[#9C9488]">
                Loading
            </small>
        </div>
    );
}

export default Preload;